// Palette + status values shared across the new inventory management screens.
// Colors mirror the Figma design (Confirm node 2009:10, Activate node 2009:104).

export const COLORS = {
  orange: "#f17400",
  navy: "#074470",
  blue: "#0196fd",
  green: "#00de3b",
  grey: "#7e7e7e",
  red: "#ff0000",
  returnedText: "#e0000f", // "Returned" status label + returned date (Figma 2009:10)
  rowDark: "rgba(246,83,20,0.2)",
  rowLight: "rgba(246,83,20,0.1)",
  rowReturned: "rgba(255,0,0,0.55)", // a returned/closed pack row in the Sales table (Figma 2382:489)
  border: "#919191",
  panelBg: "#f8f9fd",
  // Sales screens (calendar node 2065:399, day detail node 2143:121)
  editedRow: "#c7f5d3", // a row that has been edited/verified for the day
  soldOutCell: "#00de3b", // bright green highlight on a sold-out row's start/end
  calendarBorder: "#8fb8e8", // day-cell border (solidified per client feedback)
  calendarBorderStrong: "#5a93d4", // calendar outer frame + weekday divider
  pillActivation: "#7e7e7e", // Activations pill (text variant)
  pillConfirm: "#3a3f57", // Confirms pill (text variant)
  // Exact stat-card colors sampled from Figma (nodes 2083:576 / 597 / 587)
  cardSales: "#00b3ff", // SALES (also used for the current-day calendar cell)
  cardActivated: "#f65314", // ACTIVATED
  cardConfirmed: "#007d21", // CONFIRMED
};

// DB status values used by the inventoryV2 table
export const STATUS = {
  ALL: "ALL",
  CONFIRM: "CONFIRM",
  ACTIVE: "ACTIVE",
  SOLD_OUT: "SOLD_OUT",
  RETURNED: "RETURNED",
};

// Status dropdown options (label -> DB value)
export const STATUS_OPTIONS = [
  { key: "All", value: STATUS.ALL },
  { key: "Soldout", value: STATUS.SOLD_OUT },
  { key: "Active", value: STATUS.ACTIVE },
  { key: "Confirm", value: STATUS.CONFIRM },
  { key: "Returned", value: STATUS.RETURNED },
];
